/**
 * Texte zu einem Lauf aus GET lauf/, gemeinsam für „Letzte Läufe“, Protokoll und die Seite je Ablauf
 * (Konzept Steuerungen und Schnittstellen 9.2 bis 9.4). Farbregel 9.1: Rot nur für Fehler, Bernstein nur für
 * „braucht Aufmerksamkeit“, der Normalfall ohne Farbe.
 */

const ERGEBNIS = {
  WARTET: { text: "wartet" },
  LAEUFT: { text: "läuft" },
  ZU_PRUEFEN: { text: "zu prüfen", klasse: "text-bernstein" },
  WIRD_ANGEWENDET: { text: "wird angewendet" },
  ERFOLGREICH: { text: "erfolgreich" },
  MIT_FEHLERN: { text: "Mit Fehlern", klasse: "text-bernstein" },
  FEHLGESCHLAGEN: { text: "Fehlgeschlagen", schluessel: "global.notification_failed", klasse: "text-rot" },
  ABGEBROCHEN: { text: "abgebrochen" },
  UEBERHOLT: { text: "überholt" },
};

/** Arten der Abläufe in der Reihenfolge des Boards (9.2) */
export const ARTEN = [
  { key: "schnittstelle", text: "Schnittstelle", mehrzahl: "Schnittstellen" },
  { key: "versendung", text: "Versendung", mehrzahl: "Versendungen" },
  { key: "prozess", text: "Prozess", mehrzahl: "Prozesse", mehrzahlSchluessel: "global.processes" },
  { key: "systemjob", text: "Systemjob", mehrzahl: "Systemjobs" },
];

export function artText(lauf) {
  return (ARTEN.find((a) => a.key === lauf.art) || { text: lauf.art }).text;
}

/** Status, die im Filter Ergebnis „Läuft“ heissen (9.4) */
export const STATUS_LAEUFT = "WARTET,LAEUFT,WIRD_ANGEWENDET";

/** Status, die in den Filtern „Mit Fehlern“ heissen (9.2) */
export const STATUS_MIT_FEHLERN = "MIT_FEHLERN,FEHLGESCHLAGEN";

/** Filter Ergebnis mit dem Parameter status für GET lauf/ (9.4), für Protokoll und Seite je Ablauf */
export const ERGEBNIS_FILTER = [
  { key: "alle", text: "Alle", schluessel: "global.all", status: "" },
  { key: "erfolgreich", text: "Erfolgreich", schluessel: "global.successful", status: "ERFOLGREICH" },
  { key: "mitFehlern", text: "Mit Fehlern", status: "MIT_FEHLERN" },
  { key: "fehlgeschlagen", text: "Fehlgeschlagen", schluessel: "global.notification_failed", status: "FEHLGESCHLAGEN" },
  { key: "abgebrochen", text: "Abgebrochen", status: "ABGEBROCHEN" },
  { key: "laeuft", text: "Läuft", status: STATUS_LAEUFT },
];

/** Filter Auslöser mit den Parametern ausloeser und test; Testläufe zählen nur unter Testlauf */
export const AUSLOESER_FILTER = [
  { key: "alle", text: "Alle", schluessel: "global.all", parameter: {} },
  { key: "automatisch", text: "Automatisch", parameter: { ausloeser: "zeitplan", test: "n" } },
  { key: "hand", text: "Von Hand", parameter: { ausloeser: "knopf", test: "n" } },
  { key: "test", text: "Testlauf", parameter: { test: "j" } },
];

/**
 * Text eines Eintrags in der Sprache des Benutzers: mit Sprachschlüssel (schluessel, mehrzahlSchluessel) über t,
 * sonst der deutsche Text. t ist die Übersetzung der Komponente, (s) => this.$t(s); $t allein geht nicht, weil
 * vue-i18n dafür this braucht.
 */
export function uebersetzt(t, eintrag, feld = "text") {
  const schluessel = eintrag[feld === "text" ? "schluessel" : feld + "Schluessel"];
  return schluessel && t ? t(schluessel) : eintrag[feld];
}

export function ergebnisText(lauf, t) {
  return uebersetzt(t, ERGEBNIS[lauf.status] || { text: lauf.status });
}

export function ergebnisKlasse(lauf) {
  return (ERGEBNIS[lauf.status] || {}).klasse || "";
}

/**
 * Die Zusammenfassung schreibt der Ablauf. Fehlt sie, weil der Lauf abgebrochen, durch einen Neustart
 * unterbrochen oder unerwartet fehlgeschlagen ist, steht an ihrer Stelle die Meldung des Runners, grau
 * (ohne Personendaten wie die Zusammenfassung).
 */
export function zusammenfassungText(lauf) {
  return lauf.zusammenfassung || lauf.meldung || "";
}

export function zusammenfassungIstMeldung(lauf) {
  return !lauf.zusammenfassung && !!lauf.meldung;
}

/** Ablauf und Laufart mit ihren Bezeichnungen aus der Anmeldung */
export function ablaufText(lauf) {
  return `${lauf.ablaufBezeichnung || lauf.ablauf}, ${lauf.laufartBezeichnung || lauf.laufart}`;
}

/** Auslöser wie auf dem Board: automatisch, der Name bei einem Lauf von Hand, Testlauf mit Namen */
export function ausloeserText(lauf) {
  if (lauf.test) return lauf.gestartetVonName ? `Testlauf, ${lauf.gestartetVonName}` : "Testlauf";
  if (lauf.ausloeser === "zeitplan") return "automatisch";
  if (lauf.ausloeser === "ereignis") return "Ereignis";
  return lauf.gestartetVonName || "von Hand";
}

/** Dauer wie in der Lauf-Ansicht: „12 s“ oder „3 Min. 12 s“, leer, solange der Lauf nicht begonnen hat */
export function dauerText(lauf) {
  const s = lauf.dauerSekunden;
  if (s === null || s === undefined) return "";
  const min = Math.floor(s / 60);
  return min > 0 ? `${min} Min. ${s % 60} s` : `${s} s`;
}
